:host {
  --chart-scale: 160px;
}

:host(:not([state='is-active'])) {
  .chart-legend-bullet {
    background-color: var(--grey-layout-202-disabled-icons) !important;
  }
}

text.bb-chart-arcs-title {
  transform: translate(0px, 15px);
  cursor: default;

  tspan:first-of-type {
    font-weight: 400;
    font-size: var(--header-font-size-large);
    fill: var(--main-titles-inputs-600);
  }
  tspan:not(:first-of-type) {
    font-size: var(--body-size-large);
    fill: var(--main-titles-inputs-600);
  }
}

.loading-container {
  padding-top: calc(var(--spacer) * 13);
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  gap: calc(var(--spacer) * 3);

  &-resized {
    display: flex;
    padding-top: calc(var(--spacer) * 11);
    flex-flow: column;
    gap: calc(var(--spacer) * 12);
  }
}

#healthDashboardEndpointEncryption {
  padding-top: calc(var(--spacer) * 6);
  width: 100%;

  #section-content {
    display: flex;
    flex-flow: row;
    justify-content: flex-start;
    min-height: var(--chart-scale);
    gap: calc(var(--spacer) * 3);

    #chart-content {
      min-width: var(--chart-scale);
      width: var(--chart-scale);
      height: var(--chart-scale);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    #chart-legend-container {
      align-items: center;
      justify-content: flex-start;
      display: flex;
      max-width: 320px;
      min-width: 0;

      #chart-legend-list {
        display: flex;
        flex-flow: column;
        gap: var(--spacer);
        padding: 0 var(--spacer);
        min-width: 0;

        .chart-legend-item {
          display: flex;
          align-items: center;
          gap: var(--spacer);
          min-height: 32px;
          cursor: default;

          .chart-legend {
            flex: 1 1 0;
            display: flex;
            justify-content: space-between;
            gap: calc(var(--spacer) * 4);
            min-width: 0;

            .chart-legend-value {
              color: var(--main-titles-inputs-600);
              font-weight: bold;
              font-family: var(--font-family-secondary-mono);
            }

            .chart-legend-text {
              color: var(--main-titles-inputs-600);
              font-family: var(--font-family-secondary);
              font-size: var(--body-size-large);
            }
          }

          .chart-legend-bullet {
            width: 10px;
            height: 10px;
          }
        }
      }
    }

    .chart-tooltip {
      font-size: var(--tooltip-font-size);
      font-family: var(--font-family-secondary);
      color: var(--main-titles-inputs-600);
      background-color: var(--white-layout-303-level-2-elevation);
      box-shadow: 4px 4px 6px 0px var(--chart-050-hover);
      border-radius: calc(var(--spacer) * 0.5);
      padding: calc(var(--spacer) * 1.5) calc(var(--spacer) * 2);
      position: absolute;
      z-index: 2;
      transform: translate(-50%, -100%);
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: var(--spacer);
      min-width: 190px;
      span {
        font-family: var(--font-family-secondary);
      }

      .value {
        margin-left: auto;
      }
    }
  }

  &.resized {
    padding-top: calc(var(--spacer) * 2.5);

    #section-content {
      flex-flow: column;

      #chart-legend-container {
        width: 100%;
      }
    }
  }
}

gz-info-box.widget-info-box {
  --info-box-icon-padding: 0 var(--spacer) calc(var(--spacer) * 1.5) 0 !important;
  --info-box-message-padding: 0 10px calc(var(--spacer) * 2) 0;
  --info-box-width: 100%;
  --info-box-message-width: calc(100% - var(--spacer) * 7);
}
